
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter/archive",
      function () {
        return require("private-next-pages/newsletter/archive/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletter/archive"])
      });
    }
  